import React, { Component } from 'react';
// import MessengerCustomerChat from 'react-messenger-customer-chat';

export default class Messenger extends Component {
  render() {
    return (
      <div style={{marginTop:20}}>
        <div className="fb-customerchat"
          page_id={process.env.REACT_APP_MESSENGER_ID}>
        </div>
      </div>
    )
  }
}
